
import React from 'react';

import Manufacturingprose from './Manufacturingprose';
import Productionproces from './Productionproces';


const Commonmanufact = () => {
    return (
        <div>
    <Manufacturingprose />
            <Productionproces />

        </div>
    );
};

export default Commonmanufact;
